import { render, staticRenderFns } from "./NavbarElement.vue?vue&type=template&id=645c9412&scoped=true&"
import script from "./NavbarElement.vue?vue&type=script&lang=js&"
export * from "./NavbarElement.vue?vue&type=script&lang=js&"
import style0 from "./NavbarElement.vue?vue&type=style&index=0&id=645c9412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c9412",
  null
  
)

export default component.exports